<div class="mb-3">
    <label for="formFile" class="form-label">File Upload</label>
    <input class="form-control" type="file" id="formFile">
</div>